<script setup lang="ts">
import { computed } from "vue";
import { isIssuance, statusClass } from "./cnmcPresentation";
import type { CnmcPlan } from "./cnmcTypes";

const props = defineProps<{ plan: CnmcPlan }>();
const completedSteps = computed(() => {
  if (props.plan.progress === "COMPLETE") return 4;
  if (props.plan.status === "DRAFT") return 0;
  const current = props.plan.applications.filter(
    (application) => !["ABANDONED", "SUPERSEDED"].includes(application.status)
  );
  const sources = current.filter(isIssuance);
  const deliveries = current.filter((application) => !isIssuance(application));
  if (!sources.length || sources.some((application) => !application.receipt))
    return 1;
  if (
    !deliveries.length ||
    deliveries.some((application) => !application.receipt)
  )
    return 2;
  return 3;
});
</script>

<template>
  <div class="cnmc-progress">
    <div class="d-flex gap-1 mb-2" aria-hidden="true">
      <span
        v-for="index in 4"
        :key="index"
        class="cnmc-progress__segment"
        :class="{
          'bg-primary': index <= completedSteps,
          'bg-warning':
            index === completedSteps + 1 && plan.status !== 'ABANDONED',
        }"
      />
    </div>
    <span
      class="badge fw-medium text-wrap text-start"
      :class="statusClass(plan.progress)"
    >
      {{ $t(`cnmc.statuses.${plan.progress}`) }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.cnmc-progress {
  min-width: 150px;
}
.cnmc-progress__segment {
  flex: 1;
  height: 5px;
  border-radius: 2px;
  background: var(--phoenix-gray-200);
}
</style>
